import {type CommitInfoPayload, CommitInfoPayloadSchema} from '@github-ui/dotcom-schema/types/repos/tree/v1/commit_info'
import {repositoryTreePath} from '@github-ui/paths'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import type {Commit} from '@github-ui/repos-types'

import type {CodeViewPathParams} from './types/shared-query-types'

const COMMIT_INFO_PAYLOAD_TYPE_NAME: CommitInfoPayload['$typeName'] = 'github.repos.tree.v1.CommitInfoPayload'

function isCommitInfoPayload(response: CommitInfoPayload | Record<string, Commit>): response is CommitInfoPayload {
  return '$typeName' in response && response.$typeName === COMMIT_INFO_PAYLOAD_TYPE_NAME
}

export const treeCommitInfoQuery = {
  queryName: 'treeCommitInfo' as const,
  queryDeps: ({params: routeParams}: {params: Record<string, string | undefined>}) => {
    const params = routeParams as CodeViewPathParams

    return {
      pathname: repositoryTreePath({
        repo: {
          ownerLogin: params.owner,
          name: params.repo,
        },
        commitish: params.branch,
        path: params['*'],
        action: 'tree-commit-info',
      }),
    }
  },
  queryFn: async (queryKey: {queryDeps: {pathname: string}}): Promise<Record<string, Commit>> => {
    const response = await queryFnFetch<typeof CommitInfoPayloadSchema, Record<string, Commit>>(queryKey, {
      schema: CommitInfoPayloadSchema,
    })
    // temporary until we fully ship the commit_info_proto flag — the response is either the
    // proto-decoded payload (identified by its `$typeName`) or the legacy raw `Record<string, Commit>`.
    if (isCommitInfoPayload(response)) {
      return response.entries as Record<string, Commit>
    }
    return response
  },
  type: QueryRouteQueryType.Deferred,
}
